import React, {Suspense} from 'react';

import ErrorBoundary from '../components/ErrorBoundary';
import PageLoadingError from '../components/PageLoadingError';
import ChatAreaLoader from './ChatAreaLoader';

export function LazyPage({component: Component}: {component: React.FC}) {
  const handleRetry = () => {
    window.location.reload();
  };

  return (
    <ErrorBoundary
      onRetry={handleRetry}
      fallback={(props) => <PageLoadingError onRetry={props.onRetry} />}
    >
      <Suspense fallback={<ChatAreaLoader />}>
        <Component />
      </Suspense>
    </ErrorBoundary>
  );
}

LazyPage.displayName = 'LazyPage';

export default LazyPage;